var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5C0 13.8181 2.98477 10.8333 6.66667 10.8333C10.3486 10.8333 13.3333 13.8181 13.3333 17.5H0ZM7.5 12.5692V15.8333H11.3822C10.7852 14.1446 9.307 12.8722 7.5 12.5692ZM5.83333 15.8333V12.5692C4.02637 12.8722 2.54805 14.1446 1.95118 15.8333H5.83333ZM6.66667 10C3.90417 10 1.66667 7.7625 1.66667 5C1.66667 2.2375 3.90417 0 6.66667 0C9.42917 0 11.6667 2.2375 11.6667 5C11.6667 7.7625 9.42917 10 6.66667 10ZM6.66667 8.33333C8.50867 8.33333 10 6.84202 10 5C10 3.15797 8.50867 1.66667 6.66667 1.66667C4.82464 1.66667 3.33333 3.15797 3.33333 5C3.33333 6.84202 4.82464 8.33333 6.66667 8.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.4f263a7cfe00e2e38ab1e676ddbd683e.svg";
export { ForwardRef as ReactComponent };